var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCounterIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 477.1",
    style: {
      enableBackground: "new 0 0 512 477.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D6AA49;}\n\t.st1{fill:#2783EC;}\n\t.st2{fill:#439AF6;}\n\t.st3{fill:#F0F2F5;}\n\t.st4{fill:#FCCB55;}\n\t.st5{fill:#FFD880;}\n\t.st6{fill:#1F61A3;}\n\t.st7{fill:#FFE7B3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.4,341.5h51.2v93.9h-51.2V341.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.7,349.9h-1.5c-24-0.9-42.9-20.7-42.7-44.7V25.6c0-9.4,7.7-17,17.1-17.1h120.9c4.5,0,8.9,1.8,12.1,5 l24.1,24.1c3.2,3.2,7.6,5,12.1,5h103.9c9.4,0,17,7.7,17.1,17.1v34.1l-221.9,256L52.7,349.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M401.1,110.9v238.9H52.7c23-0.8,41.2-19.7,41.1-42.7V110.9c0-9.4,7.7-17,17.1-17.1H384 C393.4,93.9,401,101.5,401.1,110.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.5,128h102.4c4.7,0,8.5,3.8,8.5,8.5v51.2c0,4.7-3.8,8.5-8.5,8.5H136.5c-4.7,0-8.5-3.8-8.5-8.5v-51.2 C128,131.8,131.8,128,136.5,128z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M349.9,418.3h68.3c18.9,0,34.1,15.3,34.1,34.1v8.5c0,4.7-3.8,8.5-8.5,8.5H324.3c-4.7,0-8.5-3.8-8.5-8.5v-8.5 C315.7,433.5,331,418.3,349.9,418.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M324.3,315.9c-9.4-4.1-17.9-10.2-24.7-17.9c-22.4-22.4-35-52.8-35-84.5c0-4.7,3.8-8.5,8.5-8.5h221.9 c4.7,0,8.5,3.8,8.5,8.5c0,31.7-12.6,62.1-35,84.5c-6.9,7.7-15.3,13.8-24.7,17.9H324.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M324.3,179.3h119.5c4.7,0,8.5,3.8,8.5,8.5v110.9c0,37.7-30.6,68.3-68.3,68.3s-68.3-30.6-68.3-68.3V187.9 C315.7,183.2,319.6,179.3,324.3,179.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.4,238.9h-93.9c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5h93.9c4.7,0,8.5,3.8,8.5,8.5 S235.1,238.9,230.4,238.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196.3,273.1h-59.7c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5h59.7c4.7,0,8.5,3.8,8.5,8.5S201,273.1,196.3,273.1z "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M349.9,230.5c-4.7,0-8.5-3.8-8.5-8.5v-8.5c0-4.7,3.8-8.5,8.5-8.5c4.7,0,8.5,3.8,8.5,8.5v8.5 C358.4,226.7,354.6,230.5,349.9,230.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M384,341.5c-23.6,0-42.6-19.1-42.7-42.7v-42.7c0-4.7,3.8-8.5,8.5-8.5c4.7,0,8.5,3.8,8.5,8.5v42.7 c0,14.1,11.5,25.6,25.6,25.6c4.7,0,8.5,3.8,8.5,8.5S388.7,341.5,384,341.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterIcon2);
export default __webpack_public_path__ + "static/media/counter-icon-2.97cde3178ccc9c6d496d8d03bbd7b6d9.svg";
export { ForwardRef as ReactComponent };